import { type ChildClient } from '@models';
import { createEntityAdapter, type EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { AuthActions } from '../auth/auth.actions';
import { ClientManagementActions } from './clients-managements.actions';

export interface ChildClientState extends EntityState<ChildClient> {
  currentClientId?: string;
  isLoading: boolean;
}

export const childClientAdapter = createEntityAdapter<ChildClient>({});

export const initialChildClientState = childClientAdapter.getInitialState({
  isLoading: false,
}) as ChildClientState;

export const clientsManagementsReducer = createReducer(
  initialChildClientState,

  on(ClientManagementActions.clientIdChanged, (state, action) => {
    return { ...state, currentClientId: action.clientId };
  }),

  on(AuthActions.login, (state, action) => {
    const clients = (action.user.userClients || []) as unknown as ChildClient[];

    return childClientAdapter.setAll(clients, { ...state, isLoading: false });
  }),
  on(ClientManagementActions.loadChildClientsSuccess, (state, action) => {
    return childClientAdapter.setAll(action.clientList, { ...state, isLoading: false });
  }),
  on(ClientManagementActions.addChildClient, state => {
    return { ...state, isLoading: true };
  }),
  on(ClientManagementActions.addChildClientSuccess, (state, action) =>
    childClientAdapter.addOne(action.newClient, { ...state, isLoading: false }),
  ),
  on(ClientManagementActions.updateChildClientSuccess, (state, action) => {
    return childClientAdapter.updateOne(
      {
        changes: action.childClient,
        id: action.childClient.id,
      },
      { ...state },
    );
  }),
  on(ClientManagementActions.updateClientRequireTotpSuccess, (state, action) => {
    return childClientAdapter.updateOne(
      {
        changes: action.childClient,
        id: action.childClient.id,
      },
      { ...state },
    );
  }),
  on(ClientManagementActions.clientManagementError, state => {
    return { ...state, isLoading: false };
  }),
);
